import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const futura = "'Futura', sans-serif";

const NotFound = () => {
  return (
    <div style={{ background: "#0c0c0c", color: "white", minHeight: "100vh" }}>
      <SEO
        title="Page Not Found"
        description="That page doesn't exist. Find the Metal Brik wallet, guides, and support from the homepage."
        path="/404"
        robots="noindex, follow"
      />
      <Header />
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "60px 24px",
          fontFamily: futura,
        }}
      >
        <h1 style={{ fontSize: "clamp(32px, 5vw, 56px)", margin: "0 0 12px" }}>
          Page not found
        </h1>
        <p style={{ color: "#bbb", fontSize: "16px", margin: "0 0 28px", maxWidth: "420px" }}>
          The page you're looking for doesn't exist or moved. The wallet,
          though, is right where you left it.
        </p>
        <div style={{ display: "flex", gap: "14px", flexWrap: "wrap", justifyContent: "center" }}>
          <a
            href="/metal-wallet"
            style={{
              padding: "14px 28px",
              background: "#ff7d1a",
              color: "white",
              borderRadius: "10px",
              fontWeight: 700,
              fontSize: "14px",
              letterSpacing: "1px",
              textTransform: "uppercase",
              textDecoration: "none",
            }}
          >
            See the Metal Brik
          </a>
          <a
            href="/"
            style={{
              padding: "14px 28px",
              background: "transparent",
              color: "white",
              border: "2px solid white",
              borderRadius: "10px",
              fontWeight: 700,
              fontSize: "14px",
              letterSpacing: "1px",
              textTransform: "uppercase",
              textDecoration: "none",
            }}
          >
            Go home
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
